module.exports = {"TXTWCL_We_keep_your_data_safe":{"id":"TXTWCL_We_keep_your_data_safe","defaultMessage":"この情報を安全に保管します"}}